import { useSyncExternalStore } from "react";

export type Route = { view: "home" } | { view: "play" } | { view: "fresh" } | { view: "survival" } | { view: "trade"; coin: string } | { view: "portfolio" };

export const DEFAULT_COIN = "BTC";

export function parse(pathname: string): Route {
  const [first, second] = pathname.split("/").filter(Boolean);
  switch (first) {
    case "play":
      return { view: "play" };
    case "fresh":
      return { view: "fresh" };
    case "survival":
      return { view: "survival" };
    case "portfolio":
      return { view: "portfolio" };
    case "trade":
      return { view: "trade", coin: second && /^[a-z0-9]{1,12}$/i.test(second) ? second.toUpperCase() : DEFAULT_COIN };
    default:
      return { view: "home" };
  }
}

export function href(route: Route): string {
  switch (route.view) {
    case "home":
      return "/";
    case "trade":
      return `/trade/${route.coin}`;
    default:
      return `/${route.view}`;
  }
}

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
window.addEventListener("popstate", notify);

export function navigate(to: string, replace = false): void {
  if (to === window.location.pathname) return;
  if (replace) window.history.replaceState(null, "", to);
  else window.history.pushState(null, "", to);
  window.scrollTo({ top: 0 });
  notify();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePathname(): string {
  return useSyncExternalStore(subscribe, () => window.location.pathname);
}

export function useRoute(): Route {
  return parse(usePathname());
}
